import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { X } from 'react-feather'
import auth from '../../utils/auth'
import { useDispatch, useSelector } from 'react-redux'
import { ProfileProvider, useProfile } from './profile-hook'
import { changeLanguage } from '../../features/system/slice'
import { SystemProvider } from '../../features/system/provider'
import { RoleDropdown } from '../../pages/home/components/hero-role'
import { reset } from '../../features/account/slice'

const Avatar = ({profile, small, className, ...props}) => {
  const size = small === true ? '30px' : '40px'
  const isLogo = profile.logo
  const backgroundImage = `url('${profile.logo ? profile.logo : profile.image ? profile.image : '/images/logos/khub_peacegen.svg'}')`

  return (
    <div
      style={{backgroundImage, height: size, width: size, backgroundSize: isLogo ? '60%' : '100%', backgroundColor: '#f8f8f8'}}
      className={`bg-no-repeat bg-center rounded-full ${className}`}
      {...props}
    />
  )
}

const ProfileCard = () => {
  const { profile = {} } = useProfile()
  const { isOfficial, isVerified } = useSelector(state => state.account)

  return (
    <div className="flex items-center">
      <Avatar profile={profile} className="mr-3" />
      <Link to="/dashboard/profile">
        <div>
          <p className="font-primary normal-case text-base font-bold">{profile.name ? profile.name : 'Default'}</p>
          <p className="font-primary normal-case font-normal text-xs text-gray-999">
            {isVerified && 'Verified User'}
            {isOfficial && 'Official Member'}
            {(!isVerified && !isOfficial) && 'User'}
          </p>
        </div>
      </Link>
    </div>
  )
}

const HeaderMenu = ({setToggled}) => {
  const dispatch = useDispatch()
  const language = useSelector(state => state.system.language)
  const { isLoggedIn, isOfficial } = useSelector(state => state.account)
  const history = useHistory()

  const handleSignOut = () => {
    dispatch(reset())
    auth().logout()
    history.push('/login')
  }

  const handleLanguage = (lang) => {
    dispatch(changeLanguage(lang))
    setToggled(false)
  }

  return (
    <div className="bg-white fixed overflow-y-auto scrolling-touch w-full h-screen left-0 top-0" style={{zIndex: 900}}>
      <div className={`flex justify-between p-5 border-b ${!isLoggedIn ? 'items-center' : ''}`} style={{borderColor: '#ddd'}}>
        {
          isLoggedIn &&
          <ProfileProvider>
            <ProfileCard />
          </ProfileProvider>
        }
        {
          !isLoggedIn &&
          <Link to="/login">
            <h1 className="uppercase font-bold text-sm">Sign In</h1>
          </Link>
        }

        <div onClick={() => setToggled(false)}>
          <X className={`${isLoggedIn ? 'mt-1' : ''}`}/>
        </div>
      </div>
      <div className="container mx-auto py-8 border-b" style={{borderColor: '#ddd'}}>
        <ul>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold uppercase" to="/organization">Organizations</Link>
          </li>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold uppercase" to="/program">Programs</Link>
          </li>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold uppercase" to="/event">Events</Link>
          </li>
          <li className="mb-5">
            <Link className="font-accent text-lg font-bold uppercase" to="/resource">Resources</Link>
          </li>
          <li>
            <Link className="font-accent text-lg font-bold uppercase" to="/blog">Blog</Link>
          </li>
        </ul>
      </div>
      {
        isLoggedIn &&
        <div className="container mx-auto py-8 border-b" style={{borderColor: '#ddd'}}>
          <ul>
            {
              isOfficial &&
              <li className="mb-5">
                <Link className="text-sm" to="/dashboard">Dashboard</Link>
              </li>
            }
            <li className="mb-5">
              <Link className="text-sm" to="/dashboard/settings">Account Settings</Link>
            </li>
            <li className="mb-5">
              <p className="text-sm" onClick={handleSignOut}>Sign Out</p>
            </li>
          </ul>
        </div>
      }
      <div className="container mx-auto py-8">
        <div className="flex items-center">
          <div
            className={`uppercase font-accent font-bold text-sm ${language.name === 'en' ? '' : 'text-gray-999'}`}
            onClick={() => handleLanguage('en')}
          >
            Eng
          </div>
          <div className="uppercase font-accent font-bold text-sm text-gray-999 mx-2">/</div>
          <div
            className={`uppercase font-accent font-bold text-sm ${language.name === 'id' ? '' : 'text-gray-999'}`}
            onClick={() => handleLanguage('id')}
          >
            Ina
          </div>
        </div>

        <SystemProvider>
          <div className="mx-auto mb-3">
            <RoleDropdown layoutClass={`items-center justify-start py-8`}/>
          </div>
        </SystemProvider>
      </div>
    </div>
  )
}

export { HeaderMenu }
